var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('FedexUkraineReportEditAdmin',{attrs:{"FUR":_vm.FUR},on:{"reload":_vm.reload,"exportFedexUkraineReport":_vm.exportFedexUkraineReport}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }